import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=1aabf9ef&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=ts"
export * from "./LegalNotice.vue?vue&type=script&lang=ts"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=1aabf9ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabf9ef",
  null
  
)

export default component.exports